// 推文相关API接口
import request from "@/utils/server";

/**
 * 发布推文接口
 * @param {Object} data - 发布推文的参数
 * @param {Number} data.type - 0-仅发布 1-发布并推送到微信
 * @param {String} data.appId - 发布方式
 * @returns {Promise} 返回axios请求的Promise对象
 */
export function publishArticleAPI(data) {
  return request({
    url: "/wxz/tw/article/issue/article",
    method: "post",
    data,
  });
}

// 新建文章接口
export function createArticleAPI(data) {
  return request({
    url: "/article/json",
    method: "post",
    data,
  });
}
// 获取文章列表接口
export function getArticleListAPI(data) {
  return request({
    url: "/article/json/list",
    method: "get",
    params: data,
  });
}
// 获取文章分类接口
export function getArticleCategoryAPI(data) {
  return request({
    url: "/category/json/list",
    method: "get",
    params: data,
  });
}
// 根据分类id数组查询对应文章列表接口
export function getArticleListByCategoryIdAPI(data) {
  return request({
    url: "/article/json/list/by-categories",
    method: "post",
    data: data,
  });
}
// 根据文章id获取文章详情接口
export function getArticleDetailAPI(data) {
  return request({
    url: `/article/json/detail/${data.id}`,
    method: "get",
  });
}